// import packages
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import { Breadcrumb, Popover, Radio, } from 'antd';
import { history } from "../../configs/history";
import { useLocation, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import Amiri from "../../assets/fonts/arial.ttf"

// Import assets
import "./area-details.scss"
import {
    PDFLogo,
} from "../../assets/images";

// Import Components
import { PrimaryButton } from "../../components/ui-elements/buttons/Buttons";
import ReserveModal from "../../components/modal/ReserveModal";
import { ImagesSlider } from "../../components/ui-elements/imagesZoomSlider/ImagesSlider";
import MetaTags from "../../components/MetaTags";

// Import utils
import { getPropsFromState } from "../../redux/mapStateToProps";
import { GetHouseById, GetParkingById, ReserveHouse, GetBuildingByIdOrSlug } from "../../redux/actions";
import { AREA_TYPES, HOUSE_BADGES, } from "../../constants/constants";
import { generateFileMediaUrl, generateFileMediaUrlWithoutDefault } from "../../utils/generateMediaUrl";
import { calculator, priceWithCommas } from "../../utils/helperFunctions";
import { getUrlWithLocal } from "../../utils/getUrlWithLocal";
import { jsPDF } from "jspdf";
import { DetailsHeader } from "../../components/ui-elements/DetailsHeader";
import {ImageModal} from "../../components/ui-elements/image-modal/ImageModal";


function AreaDetails (props) {
    const componentRef = useRef();
    const [house, setHouse] = useState(null)
    const [imagesSliderOpen, setImagesSliderOpen] = useState(false)
    const [modalCurrentImageIndex, setModalCurrentImageIndex] = useState(0)
    const [modalImagePathList, setModalImagePathList] = useState([])
    const params = useParams()
    const [visible, setVisible] = useState(false);
    const floorNumber = house?.floor?.number
    const { staticTexts, selectedLanguage, buildingById, contact } = props
    const [slideIndex, setSlideIndex] = useState(0);
    const [areaPriceKey, setAreaPriceKey] = useState(null);
    let sliderRef = useRef(null);
    const location = useLocation()

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        let activePriceKey = '';
        if (house?.price) {
            activePriceKey = 'price'
        } else if (house?.renovatedPrice) {
            activePriceKey = 'renovatedPrice'
        } else if (house?.vipPrice) {
            activePriceKey = 'vipPrice'
        }
        setAreaPriceKey(activePriceKey)
    }, [house])

    useEffect(() => {
        const request = props.GetHouseById
        params?.area && request(params?.area).then((data) => {
            setHouse(data);
        }).catch(() => {
            history.push(getUrlWithLocal("/"))
        })

    }, [location?.state, selectedLanguage])

    const nextSlide = (index, setState, ref) => {
        setState(index + 1)
        if (modalImagePathList?.length - 1 === index) {
            setState(index)
        }
        ref.slickNext();
    };

    const prevSlide = (index, setState, ref) => {
        setState(index === 0 ? 0 : index - 1)
        ref.slickPrev();
    };

    const toggleVisibility = () => {
        setVisible(!visible)
    }

    const openImagesSlider = () => {
        setImagesSliderOpen(true)
        // setModalCurrentImageIndex(imageIndex);
        // setModalImagePathList(modalImagePathList);
    }

    const closeImagesSlider = () => {
        setImagesSliderOpen(false)
        setTimeout(() => {
            // setModalImagePathList([])
            // setModalCurrentImageIndex(0)
        }, 150)
    }

    const onClickFloor = (floor, num) => {
        history.push(getUrlWithLocal(`/floor/${floor}/place/${num}`))
    }

    const settings = {
        dots: false,
        arrows: false,
        swipeToSlide: false,
        focusOnSelect: false,
        infinite: false,
        slidesToShow: 6,

        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 4,
                }
            },
        ]
    };

    function jsPdfGenerator () {
        let doc = new jsPDF('p', 'pt', 'a4');
        doc.addFont(`${Amiri}`, "Amiri", "normal");
        doc.setFont("Amiri");
        doc.setFontSize(16);
        doc.text(`${staticTexts?.house_card_name}`, 40, 160)
        doc.setFontSize(14);
        doc.text(`${house?.floor?.number > 1 ? `${staticTexts?.house_right_info_title} N ${house?.areaNumber}`
            : `${staticTexts?.rout_item_title_parking} N ${house?.areaNumber}`}`, 40, 540,)
        doc.setFontSize(12);
        doc.setTextColor(`${house?.badge?.color}`);
        doc.text(`${house?.badge?.title}`, 40, 560,)
        doc.setTextColor(`black`);
        doc.text(`${staticTexts?.house_card_area_title} ${house?.area} ${staticTexts?.measurement_unit_meter} 2`, 40, 580,)
        doc.text(`${house?.price ? `${priceWithCommas(house?.price)} AMD`
            : `${staticTexts?.house_card_price_contractual}`}`, 40, 610)
        doc.text(`+374(11) 420 270`, 440, 640)
        doc.text(`${staticTexts?.footer_section_address}`, 390, 660)
        doc.setTextColor(`#CDBB99`);
        doc.text(`${'ParkLine'}`, 360, 680,)
        doc.html(document.querySelector("#result-pdf"), {
            callback: function(doc) {
                if (window.innerWidth < 1001) {
                    doc.save('file.pdf')
                } else {
                    doc.output('dataurlnewwindow', 'file.pdf');
                }
            }
        })
    }

    const breadCrumbList = [
        {
            url: '/home',
            title: staticTexts?.rout_item_home
        },
        {
            url: '/filter',
            title: staticTexts?.rout_item_building
        },
    ]
    if(house?.areaNumber){
        breadCrumbList.push(
            {
                title: `${staticTexts?.area_type_apartment} ${house?.areaNumber}`
            },
        )
    }
    const areaPriceKeyOptions = []

    if (house?.price) {
        areaPriceKeyOptions?.push({
            key: 'price',
            price: house?.price,
            name:  staticTexts?.house_price_option_repair// <- taticTexts?.house_price_option...
        })
    }
    if (house?.renovatedPrice) {
        areaPriceKeyOptions?.push({
            key: 'renovatedPrice',
            price: house?.renovatedPrice,
            name: staticTexts?.house_price_option_renovated
        })
    }
    if (house?.vipPrice) {
        areaPriceKeyOptions?.push({
            key: 'vipPrice',
            price: house?.vipPrice,
            name: staticTexts?.house_price_option_vip
        })
    }

    const price = house?.[areaPriceKey]
    const mortgagePrice = price && calculator(price, 12.8, 240, 0)

    return <div className={'HouseWrapper'}>
        <MetaTags
            title={`${floorNumber > 0 ? staticTexts?.rout_item_house : staticTexts?.rout_item_title_parking} N ${house?.areaNumber}`}/>
        <div className={'ContentWrapper'}>
            <DetailsHeader breadCrumbList={breadCrumbList}
                           staticTexts={staticTexts}
                           params={params}
                           houseId={house?.id}
                           contact={contact}
                           onPrint={jsPdfGenerator}/>
            <div className={"AreaMainContent"}>
                <div className={'LeftSide'}>
                    {
                        house?.areaNumber && <div
                            className={'area-title'}>{`${staticTexts?.area_type_apartment} № ${house?.areaNumber}`}</div>
                    }
                    <div className={'divider'}/>
                    <div className={'area-info'}>
                    <div className={'badges'}>
                            {house?.bestOffer && <div className={'badge isExclusive'}>{staticTexts?.card_badge}</div>}
                            <div className={'badge'} style={{ backgroundColor: house?.badge?.color }}>
                                {house?.badge?.title}
                            </div>
                        </div>
                        <div className={'divider'}/>
                        <div className={'areas-list'}>
                            {
                                house?.area && <div className={'list-item'}>
                                    <div className={'item-name-bold'}>{staticTexts?.house_card_area_title}</div>
                                    <div className={'line'}/>
                                    <div
                                        className={'item-area-bold'}>{`${house?.area} ${staticTexts?.measurement_unit_meter}`}<sup>2</sup>
                                    </div>
                                </div>
                            }
                            {
                                house?.yardArea ? <div className={'list-item'}>
                                    <div className={'item-name-bold'}>{staticTexts?.house_card_yard_title}</div>
                                    <div className={'line'}/>
                                    <div className={'item-area-bold'}>{`${house?.yardArea} ${staticTexts?.measurement_unit_meter}`}<sup>2</sup>
                                    </div>
                                </div> : ''
                            }
                            {
                                house?.roomsCount ? <div className={'list-item'}>
                                    <div className={'item-name-bold'}>{staticTexts?.card_room}</div>
                                    <div className={'line'}/>
                                    <div
                                        className={'item-area-bold'}>{`${house?.roomsCount}`}
                                    </div>
                                </div> : ''
                            }
                            {house?.rooms && !!house?.rooms?.length && house?.rooms.map(item => {
                                return <div className={'list-item'} key={item?.id}>
                                    <div className={'item-name'}>{item?.title}</div>
                                    <div className={'line'}/>
                                    <div
                                        className={'item-area'}>{`${item?.area} ${staticTexts?.measurement_unit_meter}`}<sup>2</sup>
                                    </div>
                                </div>
                            })}
                        </div>
                        {
                            floorNumber > 0 && <div className={`types-wrapper options_${areaPriceKeyOptions?.length}`}>
                                {areaPriceKeyOptions.map((type) => {
                                    return <div key={type?.key}
                                                className={`floor-block ${areaPriceKey === type?.key ? 'active' : ''}`}
                                                onClick={() => {
                                                    setAreaPriceKey(type?.key)
                                                }}
                                    >{type?.name}</div>
                                })}
                            </div>
                        }
                        {house && <div className={'price-block'}>
                            {price ? <div className={'card-price'}>{priceWithCommas(price)} AMD</div>
                                : <div className={'card-price'}>{staticTexts?.house_card_price_contractual}</div>}
                        </div>}
                        {mortgagePrice && <div className={"monthly-price-wrapper"}>
                            {/*<Link to={{*/}
                            {/*    pathname: getUrlWithLocal('/calculator'),*/}
                            {/*    state: house?.price*/}
                            {/*}}>*/}
                            {/*</Link>*/}
                            <span>{staticTexts?.house_right_info_monthly_payment} {priceWithCommas(mortgagePrice?.result?.totalPaymentInMonth)} {staticTexts?.house_price_month || 'AMD/мес.'}</span>
                        </div>}

                        {/* <div className={'price-wrapper'}>*/}
                        {/*    <PrimaryButton disabled={house?.badge?.id !== HOUSE_BADGES?.available?.key || house?.type===AREA_TYPES.OFFICE.key}*/}
                        {/*                   title={staticTexts?.house_right_info_reserve_now_btn} cb={toggleVisibility}/>*/}
                        {/*    {visible &&*/}
                        {/*        <ReserveModal house={house} visible={visible} toggleVisibility={toggleVisibility}/>}*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className={'RightSide'}>
                    {<div className={'left-side-slider'}>
                        {
                            <div className="slider-wrapper">
                                <div className="main-img-wrapper">
                                    <div className="main-img-content" ref={componentRef}>
                                        {house?.medias?.[slideIndex]?.path && <img
                                            src={generateFileMediaUrlWithoutDefault(house?.medias?.[slideIndex]?.path)}
                                            className={'main-img'}
                                            onClick={ openImagesSlider} alt={""}
                                        />}
                                    </div>
                                </div>
                                <div className="images-list-wrapper">
                                    {!!house?.medias?.length &&
                                    <Slider {...settings} ref={slider => (sliderRef = slider)}>
                                        {house?.medias?.map((item, index) => {
                                            return <div key={item.id}
                                                        className={`list-item ${(slideIndex === index) ? 'active' : ''}`}>
                                                <img
                                                    src={generateFileMediaUrl(item?.path)} className={'list-img'}
                                                    onClick={() => setSlideIndex(index)} alt={"about"}/>
                                            </div>
                                        })}
                                    </Slider>}
                                    {
                                        <>
                                            <button className={`slider-btn  prev-btn`}
                                                    onClick={() => prevSlide(slideIndex, setSlideIndex, sliderRef)}
                                                    disabled={slideIndex === 0}
                                            >
                                                {'<'}
                                            </button>
                                            <button
                                                className={`slider-btn next-btn`}
                                                disabled={slideIndex === house?.medias?.length - 1}
                                                onClick={() => nextSlide(slideIndex, setSlideIndex, sliderRef)}>
                                                {'>'}
                                            </button>
                                        </>
                                    }
                                </div>
                            </div>}
                    </div>}
                </div>
            </div>
        </div>
        <div className={'pdfBlock'} id={'result-pdf'}>
            <div className={'pdf-logo'}>
                <img src={PDFLogo} alt=""/>
            </div>
            <div className={'pdf-img'}>
                <img
                    src={generateFileMediaUrlWithoutDefault(house?.medias?.[slideIndex]?.path)}
                    className={'main-img'}
                />
            </div>
        </div>
        {imagesSliderOpen && <ImageModal visible={imagesSliderOpen}
                                           title={`${house?.floor?.number > 0 ? staticTexts?.rout_item_house : staticTexts?.rout_item_title_parking} N ${house?.areaNumber || house?.parkingNumber}`}
                                           modalImagePathList={house?.medias?.map(item=>item?.path)}
                                           modalCurrentImageIndex={slideIndex}
                                           closeModal={closeImagesSlider}/>}
    </div>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'contact',
    'selectedLanguage',
    'renovatedPrice',
    'banksList',
    'buildingById',
    'badges',
]);

const mapDispatchToProps = {
    GetHouseById,
    GetParkingById,
    ReserveHouse,
    GetBuildingByIdOrSlug
};

export default connect(mapStateToProps, mapDispatchToProps)(AreaDetails);
